import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AssetErrorComponent } from '@components/asset/asset-error/asset-error.component';
import { VideoShotAsset } from '@models/Sessions/Idea/VideoProject';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

import { VideoAssetMetadataComponent } from '../video-asset-metadata/video-asset-metadata.component';
import { VideoAssetResourceComponent } from '../video-asset-resource/video-asset-resource.component';
import { VideoClipFormControl } from '../video-project.form';

@Component({
  selector: 'app-video-shot-asset',
  standalone: true,
  imports: [
    CommonModule,
    MessageModule,
    ButtonModule,
    AssetErrorComponent,
    VideoAssetResourceComponent,
    VideoAssetMetadataComponent,
  ],
  templateUrl: './video-shot-asset.component.html',
  styleUrl: './video-shot-asset.component.scss',
})
export class VideoShotAssetComponent {
  @ViewChild('resource', { static: false })
  resource: VideoAssetResourceComponent;

  @ContentChild('generating') generating: TemplateRef<any>;
  @ContentChild('error') error: TemplateRef<any>;
  @ContentChild('ready') ready: TemplateRef<any>;

  @Input() clip: FormGroup<VideoClipFormControl>;
  @Input() hidden = false;
  @Input() resourceProps: Partial<
    Pick<VideoAssetResourceComponent, 'controls' | 'playOnHover'>
  > = {};

  get asset(): VideoShotAsset {
    return this.clip.value.asset;
  }
}
